// extracted by mini-css-extract-plugin
export default {"Label":"aggregate-labels-module__Label--Uddnw","default":"aggregate-labels-module__default--J7VTM","danger":"aggregate-labels-module__danger--WFNlo"};